"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorMessage = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../Typography"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deprecated = _interopRequireDefault(require("prop-types-extra/lib/deprecated"));

var _react = _interopRequireWildcard(require("react"));

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ErrorMessage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ErrorMessage, _Component);

  var _super = _createSuper(ErrorMessage);

  function ErrorMessage() {
    var _this;

    (0, _classCallCheck2.default)(this, ErrorMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMessage", function () {
      var _this$props = _this.props,
          message = _this$props.message,
          title = _this$props.title,
          preset = _this$props.preset,
          children = _this$props.children;
      var messages = {
        403: {
          title: "Unauthorized (403)",
          message: "You do not have permission to access this resource."
        },
        404: {
          title: "Not Found (404)",
          message: "The resource you are looking for has been removed, had its name changed, or is temporarily unavailable."
        }
      };
      return {
        title: title ? title : preset in messages && messages[preset].title,
        message: children ? children : message ? message : preset in messages && messages[preset].message
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getIcon", function () {
      var type = _this.props.type;

      if (type === "warning") {
        return /*#__PURE__*/_react.default.createElement(_Warning.default, {
          fontSize: "inherit"
        });
      } else if (type === "info") {
        return /*#__PURE__*/_react.default.createElement(_Info.default, {
          fontSize: "inherit"
        });
      } else if (type === "error") {
        return /*#__PURE__*/_react.default.createElement(_Error.default, {
          fontSize: "inherit"
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getColorClass", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          classes = _this$props2.classes;

      if (type === "warning") {
        return classes.warning;
      } else if (type === "info") {
        return classes.info;
      } else if (type === "error") {
        return classes.error;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props3 = _this.props,
          id = _this$props3.id,
          classes = _this$props3.classes,
          align = _this$props3.align,
          gutterBottom = _this$props3.gutterBottom,
          gutterTop = _this$props3.gutterTop;

      var messageContent = _this.getMessage();

      var colorClassName = _this.getColorClass();

      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        direction: "column",
        id: id,
        className: (0, _classnames.default)("prmbl-ErrorMessage", classes.root, (0, _defineProperty2.default)({}, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)({}, classes.gutterTop, gutterTop))
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h4",
        align: align
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.icon, colorClassName)
      }, _this.getIcon()), /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.title, colorClassName)
      }, messageContent.title)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body1",
        className: classes.message,
        align: align
      }, messageContent.message));
    });
    return _this;
  }

  return ErrorMessage;
}(_react.Component);

exports.ErrorMessage = ErrorMessage;
(0, _defineProperty2.default)(ErrorMessage, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The title shown large
   */
  title: _propTypes.default.string,

  /**
   * @deprecated
   * Use a child node instead
   */
  message: (0, _deprecated.default)(_propTypes.default.node, "Deprecation warning: This ErrorMessage uses the deprecated `message` prop. Use a child node instead."),

  /**
   * The error message
   */
  children: _propTypes.default.node,

  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(["left", "center"]),

  /**
   * If `true`, the text will have a top margin.
   */
  gutterTop: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * The type of error.
   */
  type: _propTypes.default.oneOf(["warning", "error", "info"]),

  /**
   * Use a preset error
   */
  preset: _propTypes.default.oneOf(["403", "404"])
});
(0, _defineProperty2.default)(ErrorMessage, "defaultProps", {
  align: "left",
  gutterTop: false,
  gutterBottom: true,
  type: "error"
});

var _default = (0, _styles.withStyles)(_styles2.styles)(ErrorMessage);

exports.default = _default;